import { isTextPinComponent, PinComponent } from '@lessonup/pins-shared';

export function getDefaultBackgroundColor(pinComponent: PinComponent) {
  if (isTextPinComponent(pinComponent)) {
    return 'transparent';
  }

  return '#FFFFFF';
}
